import { Fragment } from 'react'
import PropTypes from 'prop-types'
import 'what-input'

import HelmetSEO from '~partials/global/HelmetSEO'
import useScrollTracker from '~hooks/useScrollTracker'

const Foundation = ({ children }) => {
  useScrollTracker()

  return (
    <Fragment>
      <HelmetSEO />
      {children}
    </Fragment>
  )
}

Foundation.propTypes = {
  children: PropTypes.node,
}

export default Foundation
